import { render, staticRenderFns } from "./AccountChannels.vue?vue&type=template&id=4cc208b4&"
import script from "./AccountChannels.vue?vue&type=script&lang=js&"
export * from "./AccountChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports